"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var RotatedText = /*#__PURE__*/function (_Component) {
  function RotatedText() {
    _classCallCheck(this, RotatedText);
    return _callSuper(this, RotatedText, arguments);
  }
  _inherits(RotatedText, _Component);
  return _createClass(RotatedText, [{
    key: "getTransform",
    value: function getTransform(orientation) {
      var result = "";
      switch (orientation) {
        case 'RotateLeft':
          result = "rotate(-90deg)";
          break;
        case 'RotateRight':
          result = "rotate(90deg)";
          break;
        default:
          break;
      }
      return result;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        children = _this$props.children,
        width = _this$props.width,
        height = _this$props.height,
        orientation = _this$props.orientation,
        horizontalAlignment = _this$props.horizontalAlignment,
        verticalAlignment = _this$props.verticalAlignment;
      var transform = this.getTransform(orientation);
      var size = null;
      if (orientation === "Horizontal") {
        size = {
          width: width + "px",
          height: height + "px",
          maxWidth: width + "px",
          maxHeight: height + "px"
        };
      } else {
        size = {
          width: height + "px",
          height: width + "px",
          maxWidth: height + "px",
          maxHeight: width + "px",
          left: Math.round(width / 2.0 - height / 2.0) + "px",
          top: Math.round(height / 2.0 - width / 2.0) + "px"
        };
      }
      var style = _objectSpread({
        position: "absolute",
        padding: 0,
        margin: 0,
        lineHeight: 1,
        textAlign: horizontalAlignment,
        WebkitTransformOrigin: "center center",
        MozTransformOrigin: "center center",
        OTransformOrigin: "center center",
        msTransformOrigin: "center center",
        WebkitTransform: transform,
        MozTransform: transform,
        OTransform: transform,
        msTransform: transform,
        transform: transform,
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        overflow: "hidden",
        tableLayout: "fixed"
      }, size);
      return verticalAlignment === 'top' ? /*#__PURE__*/_react["default"].createElement("div", {
        style: style
      }, children) : /*#__PURE__*/_react["default"].createElement("table", {
        style: _objectSpread(_objectSpread({}, style), {}, {
          borderCollapse: "collapse"
        })
      }, /*#__PURE__*/_react["default"].createElement("tbody", null, /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("td", {
        style: {
          verticalAlign: verticalAlignment,
          padding: 0,
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          overflow: "hidden"
        }
      }, children))));
    }
  }]);
}(_react.Component);
_defineProperty(RotatedText, "propTypes", {
  width: _propTypes["default"].number.isRequired,
  height: _propTypes["default"].number.isRequired,
  orientation: _propTypes["default"].oneOf(['Horizontal', 'RotateLeft', 'RotateRight']),
  horizontalAlignment: _propTypes["default"].oneOf(['left', 'center', 'right']),
  verticalAlignment: _propTypes["default"].oneOf(['top', 'middle', 'bottom'])
});
_defineProperty(RotatedText, "defaultProps", {
  orientation: 'RotateRight',
  horizontalAlignment: 'center',
  verticalAlignment: 'middle'
});
var _default = exports["default"] = RotatedText;